export default function getOutcomesForServiceType(serviceTypeId, serviceTypes = []) {
  const filtered = serviceTypes.filter((st = {}) => st.service_type_id === serviceTypeId);
  return filtered.reduce((acc, curr) => ([...acc, ...curr.outcomes]), []);
}
